function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { getCameraOptions } from '@isyc-react/form-file/modules/drop-file/drop-camera';
import { DropZoneFile } from '@isyc-react/form-file/modules/drop-file/drop-zone';
import { InputSelect } from '@isyc-react/form/modules/input/select';
import { DocumentTypeFormat, DocumentalTypologyResult } from '@isyc-react/types';
import { nsnewo } from "../../../../i18n/namespaces";
import { DropSingleAcceptedFile } from "../../drop-single-view/drop-single-accepted-view-component";
import { DropFileDefaultView } from "../../drop-single-view/drop-single-default-view-component";
import { DropSingleLayout } from "../../drop-single-view/drop-single-layout.component";
import { RejectedFile } from "../../drop-single-view/drop-single-rejected-view-component";
import { ArchiveInputState } from "../../../types/deprecated-documental-validation";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { allowedMimeTypes } from "../deprecated-documental-validation";
import { DocumentalValidationError } from "../deprecated-documental-validation-error.component";
const DocumentalDropFileStatus = props => {
  const {
    Select,
    title,
    open
  } = props;
  if (props.state.accepted || props.archiveInputState == ArchiveInputState.Uploaded) {
    var _props$state$accepted, _props$uploadedArchiv, _props$uploadedArchiv2;
    const fileValue = {
      file: (_props$state$accepted = props.state.accepted) !== null && _props$state$accepted !== void 0 ? _props$state$accepted : undefined,
      api: props.archiveInputState == ArchiveInputState.Uploaded ? {
        id: (_props$uploadedArchiv = props.uploadedArchiveId) !== null && _props$uploadedArchiv !== void 0 ? _props$uploadedArchiv : 0,
        name: (_props$uploadedArchiv2 = props.uploadedArchiveName) !== null && _props$uploadedArchiv2 !== void 0 ? _props$uploadedArchiv2 : ''
      } : undefined
    };
    return /*#__PURE__*/React.createElement(DropSingleLayout, {
      title: title,
      open: open
    }, Select && /*#__PURE__*/React.createElement(Select, null), /*#__PURE__*/React.createElement(DropSingleAcceptedFile, {
      fileValue: fileValue,
      archiveInputState: props.archiveInputState,
      open: props.open,
      remove: props.removeAccepted,
      disabled: props.disabled,
      documentalTypologyResult: props.documentalTypologyResult,
      camera: props.camera,
      accept: props.setAccepted
    }));
  } else if (props.state.rejected) {
    return /*#__PURE__*/React.createElement(DropSingleLayout, {
      title: title,
      open: open,
      className: "invalidate"
    }, Select && /*#__PURE__*/React.createElement(Select, null), /*#__PURE__*/React.createElement(RejectedFile, {
      rejected: [props.state.rejected],
      disabled: props.disabled
    }));
  } else {
    return /*#__PURE__*/React.createElement(DropSingleLayout, {
      title: title,
      open: open,
      bodyClassName: "filebox"
    }, Select && /*#__PURE__*/React.createElement(Select, null), /*#__PURE__*/React.createElement(DropFileDefaultView, {
      disabled: props.disabled,
      camera: props.camera
    }));
  }
};

//DROP FILE

export const DeprecatedDocumentalDropFile = props => {
  const {
    title,
    archiveInputState,
    disabled = false,
    minSize = 0,
    maxSize = Infinity,
    uploadedArchiveId,
    uploadedArchiveName,
    documentalTypologyResult,
    options,
    selectValue,
    selectDisabled,
    documentTypeFormat,
    errors,
    accept = allowedMimeTypes,
    camera = true,
    onAccepted,
    onRejected,
    onOptionSelected,
    onRemoveAccepted,
    onRemoveRejected,
    onAcceptedFront,
    onRemoveAcceptedFront,
    onRejectedFront,
    onRemoveRejectedFront,
    onAcceptedBack,
    onRemoveAcceptedBack,
    onRejectedBack,
    onRemoveRejectedBack
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  const [state, setState] = React.useState({
    accepted: null,
    rejected: null
  });
  const cameraOptions = React.useMemo(() => getCameraOptions(camera, accept), [camera, accept]);
  const onDropAccepted = acceptedFiles => {
    setState(state => _objectSpread(_objectSpread({}, state), {}, {
      accepted: acceptedFiles[0],
      rejected: null
    }));
    onAccepted && onAccepted(acceptedFiles[0]);
  };
  const onDropRejected = rejectedFiles => {
    setState(state => _objectSpread(_objectSpread({}, state), {}, {
      rejected: rejectedFiles[0],
      accepted: null
    }));
    onRejected && onRejected(rejectedFiles[0].file);
  };
  const SelectFC = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, options && options.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "mb-4"
    }, /*#__PURE__*/React.createElement(InputSelect, {
      value: selectValue,
      isDisabled: selectDisabled,
      isSearchable: false,
      placeholder: t('newo.documentalValidation.drop.selectPlaceholder') // TODO i18n, bueno y en todos lados :)
      ,
      options: options,
      noOptionsMessage: ({
        inputValue
      }) => t('newo.documentalValidation.drop.noOptions', {
        name: inputValue
      }),
      onChange: selected => onOptionSelected && onOptionSelected(selected)
    })));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropZoneFile, {
    disabled: disabled,
    minSize: minSize,
    maxSize: maxSize,
    multiple: false,
    accept: accept //File type (ie: pdf, png)
    ,
    onDropAccepted: onDropAccepted,
    onDropRejected: onDropRejected,
    className: getClassName(documentalTypologyResult)
  }, ({
    open
  }) => /*#__PURE__*/React.createElement(React.Fragment, null, documentTypeFormat === DocumentTypeFormat.FRONT_BACK && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "card-header pt-4 pt-xl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 pb-3 pb-xl-0 text-xl-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "card-title fw-semibold"
  }, title)))), /*#__PURE__*/React.createElement(DeprecatedDocumentalDropFile, {
    title: "Recto *",
    maxSize: maxSize,
    archiveInputState: archiveInputState,
    disabled: archiveInputState == ArchiveInputState.Uploading,
    uploadedArchiveId: uploadedArchiveId,
    uploadedArchiveName: uploadedArchiveName,
    onAccepted: onAcceptedFront,
    onRemoveAccepted: onRemoveAcceptedFront,
    onRejected: onRejectedFront,
    onRemoveRejected: onRemoveRejectedFront
  }), /*#__PURE__*/React.createElement(DeprecatedDocumentalDropFile, {
    title: "Verso *",
    maxSize: maxSize,
    disabled: archiveInputState == ArchiveInputState.Uploading,
    archiveInputState: archiveInputState,
    uploadedArchiveId: uploadedArchiveId,
    uploadedArchiveName: uploadedArchiveName,
    onAccepted: onAcceptedBack,
    onRemoveAccepted: onRemoveAcceptedBack,
    onRejected: onRejectedBack,
    onRemoveRejected: onRemoveRejectedBack
  })), documentTypeFormat !== DocumentTypeFormat.FRONT_BACK && /*#__PURE__*/React.createElement(DocumentalDropFileStatus, {
    Select: SelectFC,
    title: title,
    state: state,
    camera: cameraOptions,
    open: open,
    disabled: disabled,
    archiveInputState: archiveInputState,
    uploadedArchiveId: uploadedArchiveId,
    uploadedArchiveName: uploadedArchiveName,
    documentalTypologyResult: documentalTypologyResult,
    setAccepted: file => {
      setState(state => {
        const accepted = state.accepted || file;
        return _objectSpread(_objectSpread({}, state), {}, {
          accepted
        });
      });
    },
    removeAccepted: () => {
      setState(state => _objectSpread(_objectSpread({}, state), {}, {
        accepted: null
      }));
      onRemoveAccepted && onRemoveAccepted();
    },
    removeRejected: () => {
      setState(state => _objectSpread(_objectSpread({}, state), {}, {
        rejected: null
      }));
      onRemoveRejected && onRemoveRejected();
    }
  }), errors === null || errors === void 0 ? void 0 : errors.map((error, j) => /*#__PURE__*/React.createElement("p", {
    key: j
  }, /*#__PURE__*/React.createElement(DocumentalValidationError, {
    code: error
  }))))));
};
const getClassName = documentalTypologyResult => {
  switch (documentalTypologyResult) {
    case DocumentalTypologyResult.TYPOLOGY_RESULT_VALID:
      {
        return 'validate';
      }
    case DocumentalTypologyResult.TYPOLOGY_RESULT_INVALID:
      {
        return 'invalidate';
      }
    default:
      {
        return '';
      }
  }
};